import { Annotation } from 'utilities/types';

type NoiseVisibility = {
  /** human-annotated noise (the "Noise" chart setting) */
  U: boolean;
  /** automatic noise (the "Auto noise" chart setting, on by default) */
  AutoNoise: boolean;
};

/**
 * Noise intervals come from two sources (project_management#542/#552): human
 * annotators, and the analysis — the stretches it cut out before R-peak
 * detection (`isFromAnalysis`, tagged with `detector`). Each source has its
 * own chart-settings switch; this picks the rows the user asked for.
 */
export const filterNoisesBySource = (noises: Annotation[], visibility: NoiseVisibility): Annotation[] =>
  noises.filter((noise) => (noise.isFromAnalysis ? visibility.AutoNoise : visibility.U));
